<template>
  <m-form
    :title="title"
    :canSubmit="canSubmit"
    :canDelete="false"
    :is-editing="true"
    :showListBtn="false"
    :show-navigation-btns="false"
    :showList="false"
    :showSubmitAndClearBtn="false"
    @clearForm="clearForm"
    @submit="submit(true)"
  >
    <template #header-btns>
      <v-btn
        color="light-blue white--text"
        class="mr-1 mt-1 mt-md-0"
        :href="templateUrl"
        target="_blank"
        tag="a"
        rel="noopener noreferrer"
        >دانلود قالب</v-btn
      >
    </template>
    <template #default>
      <v-row>
        <v-col md="12">
          قالب اکسل را دانلود کنید و کالا های خود را بر اساس ستون ها وارد کنید، سپس فایل را آپلود کنید تا حساب ها به
          صورت خودکار ساخته شوند
        </v-col>
        <v-col md="12">
          <m-file-input label="فایل" v-model="item.file" ref="fileInput" />
        </v-col>
      </v-row>
    </template>
  </m-form>
</template>
<script>
import { MFormMixin } from "@/components/m-form";
import WareApiMixin from "@/mixin/wareApi";
export default {
  mixins: [MFormMixin, WareApiMixin],
  props: {
    level: {
      requried: true,
    },
    isService: {
      default: false,
    },
  },
  data() {
    return {
      item: {
        file: null,
        level: null,
        is_service: null,
      },
      hasConfirmation: true,
      formData: true,
      baseUrl: "wares/wares/import",
    };
  },
  computed: {
    title() {
      return "وارد کردن " + this.getWareTitle(this.level);
    },
    templateUrl() {
      return this.endpoint(this.baseUrl + `?level=${this.level}&is_service=${this.isService}&token=${this.token}`);
    },
  },
  mounted() {
    this.item.level = this.level;
    this.item.is_service = this.isService;
  },
  methods: {
    clearForm() {
      this.item.level = this.level;
      this.item.is_service = this.isService;
      this.item.file = null;
      this.$refs.fileInput.$refs.vFileInput.clearableCallback();
    },
  },
};
</script>
